package one.healthium.insights.data.mapper

import one.healthium.insights.data.dto.ActionDto
import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.ContentPreviewModel
import one.healthium.insights.domain.models.ShoppingItemModel
import one.healthium.insights.domain.models.ShoppingItemUnitModel
import one.healthium.insights.domain.models.ShoppingListModel
import one.healthium.insights.domain.models.UnitModel

internal class ActionMapper(
    private val mealNutritionMapper: MealNutritionMapper,
) {

    fun dtoToModel(action: ActionDto): ActionModel? = when (action) {
        is ActionDto.Video -> ActionModel.Video(
            url = action.url,
        )

        is ActionDto.Insight -> ActionModel.Insight(
            id = action.id,
        )

        is ActionDto.Recipe -> ActionModel.Recipe(
            id = action.id,
        )

        is ActionDto.Category -> ActionModel.Category(
            id = action.id,
        )

        is ActionDto.Workout -> ActionModel.Workout(
            id = action.id,
        )

        is ActionDto.ShoppingList -> ActionModel.ShoppingList(
            shoppingList = ShoppingListModel(
                id = action.shoppingList.id,
                name = action.shoppingList.name,
                items = action.shoppingList.items.map { itemDto ->
                    ShoppingItemModel(
                        id = itemDto.id,
                        name = itemDto.name,
                        category = itemDto.category,
                        emoji = itemDto.emoji,
                        quantity = itemDto.quantity,
                        unit = itemDto.unit?.let { unitDto ->
                            ShoppingItemUnitModel(
                                metric = unitDto.metric?.let {
                                    UnitModel(
                                        amount = it.amount,
                                        unit = unitDto.metric.unit,
                                    )
                                },
                                imperial = unitDto.imperial?.let {
                                    UnitModel(
                                        amount = it.amount,
                                        unit = unitDto.imperial.unit,
                                    )
                                },
                            )
                        },
                    )
                }
            ),
        )

        is ActionDto.Anchor -> ActionModel.Anchor(id = action.id)

        is ActionDto.LogMeal -> ActionModel.LogMeal(
            nutrition = mealNutritionMapper.dtoToModel(action.nutrition)
        )

        is ActionDto.UpdateFoodPreferences -> ActionModel.UpdateFoodPreferences

        is ActionDto.Favorite -> {
            ActionModel.Favorite(
                contentPreview = ContentPreviewModel(
                    title = action.content.title,
                    description = action.content.description,
                    thumbUrl = action.content.thumbUrl,
                )
            )
        }

        is ActionDto.Share -> ActionModel.Share

        ActionDto.Default -> null
    }
}